// How Worth a look's lists are made (SCENARIOS E1, PLAN-2026-10-27-worth-a-look
// §3): the words behind the info button on the League page's card and the
// screen's title. One copy, so the two never say different things. Facts about
// how a player gets on a list, never a word about adding him.

import { InfoButton } from '../../kit/InfoButton';
import { Stack, Text } from '../../kit/ui';

export function WorthSteps() {
  return (
    <Stack gap={2}>
      <Text size="sm" block>
        Players on no team in this league, at each position your lineup starts: the three with the
        most points a game over the league’s last two weeks that have ended, in your league’s
        scoring.
      </Text>
      <Text size="sm" block>
        A player needs a game in those weeks to be listed, and one ruled out this week is left off.
        A bye is a week his club had no game.
      </Text>
      <Text size="sm" block>
        Next man up is a player next on his club’s depth chart behind a starter who is out or
        doubtful this week.
      </Text>
      <Text size="sm" tone="secondary" block>
        It changes as the weeks end and as players are added. Players has everybody else.
      </Text>
    </Stack>
  );
}

/** The ⓘ beside Worth a look's name: how the lists are made, when asked. */
export function WorthInfo() {
  return (
    <InfoButton label="How Worth a look works" title="How Worth a look works">
      <WorthSteps />
    </InfoButton>
  );
}
